import { useTacticHooks } from '../../providers/TacticHooksProvider';
import { useQuery } from '@tanstack/react-query';

export interface UseResourceOptions {
  enabled?: boolean;
}

export const useResource = (
  resourceId: string | null | undefined,
  options?: UseResourceOptions
) => {
  const { api } = useTacticHooks();
  const { data: resource, error, isLoading } = useQuery({
    queryKey: ['resource', resourceId],

    queryFn: async () => {
      if (!resourceId) return null;
      const res = await api.client.organizations.resourceGet(resourceId);

      return res.result?.resource;
    },

    enabled: options?.enabled !== false && resourceId !== null
  });

  const loading = !resource && !error;
  // `loading` stays true for a resource that came back empty (or while the
  // query is disabled); `isLoading` is only the fetch itself, for callers
  // that must not wait forever on a missing resource.
  return { resource, error, loading, isLoading };
};
